import Vue from 'vue'

export default {
  install() {
    Vue.prototype.$PAGE_NUM = 1;
    Vue.prototype.$PAGE_SIZE = 20;
  }
}
